import { useQuery } from "@tanstack/react-query";
import { DefaultOptionType } from "antd/es/select";
import { mapSelectOptions } from "../../../utils/map4select";
import { centralRegistryKeys } from "./centralRegistry.keys";
import { centralRegistryService } from "./centralRegistry.service";
import {
  MfListaObjekataPsPayload,
  MfTipObjektaOption,
} from "./centralRegistry.types";

export function useMfTipoviObjekata() {
  return useQuery({
    ...centralRegistryKeys.mfTipoviObjekata(),
    queryFn: () => centralRegistryService.getMfTipoviObjekata(),
    select: (response): DefaultOptionType[] =>
      mapSelectOptions<MfTipObjektaOption>({
        labelAccessor: "label",
        valueAccessor: "value",
        sourceArray: response.data ?? [],
      }),
    retry: false,
  });
}

export function useMfListaObjekataPsList({
  filters,
  enabled,
}: {
  filters: MfListaObjekataPsPayload;
  enabled?: boolean;
}) {
  return useQuery({
    ...centralRegistryKeys.mfListaObjekataPs({ filters }),
    queryFn: () => centralRegistryService.postMfListaObjekataPs(filters),
    retry: false,
    enabled,
  });
}
